import { render, staticRenderFns } from "./public-mobile.vue?vue&type=template&id=202ec8c2&scoped=true&"
import script from "./public-mobile.vue?vue&type=script&lang=js&"
export * from "./public-mobile.vue?vue&type=script&lang=js&"
import style0 from "./public-mobile.vue?vue&type=style&index=0&id=202ec8c2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "202ec8c2",
  null
  
)

export default component.exports